export interface TipoProcesso {
    id: string;
    nome: string | null;
    descricao: string | null;

}

export const IStipoProcesso: TipoProcesso = {
    id: "",
    nome: "",
    descricao: "",

}